import { LoadingStates } from '@pb/utils'
import { values, curry } from 'ramda'
import { createSelector } from 'reselect'

import { KlarnaState, Payments, MemberInfo, StoreActivationInfoLink } from '../types'

const getKlarna = (state): KlarnaState => state.klarna
const getPayments = (state): Payments => getKlarna(state).payments
const getPaymentsInitStatus = (state): LoadingStates => getPayments(state).initStatus
const getAllPaymentMethodCategories = (state): any => getPayments(state).paymentMethodCategory
const getIsKlarnaPaymentsApproved = createSelector(
  getAllPaymentMethodCategories,
  (paymentMethodCategories) =>
    paymentMethodCategories && values(paymentMethodCategories).some(({ approved }) => approved),
)
const getPaymentMethodCategory = curry(
  (state, paymentMethodCategory) =>
    getAllPaymentMethodCategories(state)[paymentMethodCategory] || {},
)
const getPaymentsAuthStatus = (state): LoadingStates => getPayments(state).authStatus

const getStoreActivation = (state): any => getKlarna(state).storeActivation
const getStoreActivationSessionStatus = (state): LoadingStates =>
  getStoreActivation(state).sessionStatus
const getStoreActivationSessionBody = (state): any => getStoreActivation(state).klarnaSessionBody
const getStoreActivationPaymentMethodCategory = (state): any =>
  getStoreActivation(state).paymentMethodCategory

const getStoreActivationInfo = (state): StoreActivationInfoLink | undefined =>
  getKlarna(state).storeActivationInfo?.storeActivationInfoLink

const getMemberInfo = (state): MemberInfo => getKlarna(state).memberInfo
const getIsMemberInfoValidated = (state): boolean => getMemberInfo(state).validated

export default {
  getPaymentsInitStatus,
  getPaymentMethodCategory,
  getPaymentsAuthStatus,
  getAllPaymentMethodCategories,
  getStoreActivationSessionStatus,
  getStoreActivationSessionBody,
  getStoreActivationPaymentMethodCategory,
  getIsKlarnaPaymentsApproved,
  getStoreActivationInfo,
  getMemberInfo,
  getIsMemberInfoValidated,
}
